import { FC } from "react";
import { IconProps } from "./types";

export const CheckMarkThin: FC<IconProps> = ({
  fill = "#111",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M21.633 4.467a1.246 1.246 0 0 0-1.766 0L7.458 16.88l-3.333-3.334a1.254 1.254 0 0 0-1.759 1.787l4.217 4.2a1.246 1.246 0 0 0 1.698.058l-.002.001.071-.058 13.292-13.3a1.246 1.246 0 0 0-.009-1.767z"
      fill={fill}
    />
  </svg>
);
